"use client";

import type { ChoghadiyaPeriod } from "@/lib/api/panchang";
import { getQualityColor, getQualityLabel } from "./utils";

interface PeriodRowProps {
  period: ChoghadiyaPeriod;
}

function PeriodRow({ period }: PeriodRowProps) {
  const colors = getQualityColor(period.quality);
  return (
    <div
      className={`flex items-center justify-between p-3 sm:p-4 rounded-lg transition-all ${
        period.is_current ? "ring-2" : ""
      } border border-ish-border-light`}
      style={{
        backgroundColor: period.is_current ? colors.bg : "rgba(0,0,0,0.02)",
        borderColor: period.is_current ? colors.border : undefined,
        outlineColor: period.is_current ? colors.text : undefined,
      }}
    >
      <div className="flex items-center gap-3">
        <span
          className="w-2.5 h-2.5 rounded-full flex-shrink-0"
          style={{ backgroundColor: colors.text }}
        />
        <div>
          <span className="text-[14px] font-semibold text-ish-dark">{period.name}</span>
          <span className="text-[12px] ml-1.5 text-ish-text-faint">{period.name_hi}</span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <span
          className="text-[11px] font-semibold px-2 py-0.5 rounded-full border"
          style={{
            backgroundColor: colors.bg,
            color: colors.text,
            borderColor: colors.border,
          }}
        >
          {getQualityLabel(period.quality)}
        </span>
        <span className="text-[13px] font-medium tabular-nums text-ish-dark">
          {period.start_time} - {period.end_time}
        </span>
        {period.is_current && (
          <span
            className="text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded"
            style={{
              backgroundColor: colors.bg,
              color: colors.text,
            }}
          >
            Now
          </span>
        )}
      </div>
    </div>
  );
}

interface ChoghadiyaTableProps {
  title: string;
  titleHi: string;
  periods: ChoghadiyaPeriod[];
  timeRange: string;
}

export function ChoghadiyaTable({ title, titleHi, periods, timeRange }: ChoghadiyaTableProps) {
  return (
    <div className="card-sacred p-6 sm:p-8">
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <h2 className="text-[18px] font-bold font-serif text-ish-dark">{title}</h2>
          <span className="text-[12px] text-ish-text-faint">{titleHi}</span>
        </div>
        <span className="text-[12px] font-medium text-ish-text-muted">{timeRange}</span>
      </div>
      <div className="space-y-2">
        {periods.map((period, i) => (
          <PeriodRow key={`${period.name}-${i}`} period={period} />
        ))}
      </div>
    </div>
  );
}
